import { Component, Input } from '@angular/core'
import {
  Carrier,
  CARRIER_PROVIDERS,
  CARRIER_TYPES,
} from '@evologi/shared/data-access-api'

@Component({
  selector: 'op-carrier-logo',
  templateUrl: './carrier-logo.component.html',
  styleUrls: ['./carrier-logo.component.scss'],
})
export class CarrierLogoComponent {
  @Input({ required: true }) carrier!: Carrier
  @Input() showName = false
  @Input() showProvider = false
  @Input() centered = false

  @Input() size: 'sm' | 'md' | 'lg' = 'md'

  // Models
  public carriers = CARRIER_TYPES
  public providers = CARRIER_PROVIDERS
}
